<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>资讯管理</p>
    </div>
    <div class="panel-content">
      <form
        id="searchSection"
        onSubmit="return false;"
      >
        <input
          type="text"
          placeholder="标题"
          class="s-input separate"
          v-model="queryInfo.title"
        >
        <input
          type="date"
          placeholder="发布日期开始"
          class="s-input separate"
          v-model="queryInfo.publishDate_min"
        >
        <input
          type="date"
          placeholder="发布日期结束"
          class="s-input separate"
          v-model="queryInfo.publishDate_max"
        >
        <select
          class="s-select separate"
          v-model="queryInfo.status"
        >
          <option value="">选择发布状态</option>
          <option
            v-for="(val,key) in infoSatus"
            :key="key"
            :value="key"
          >{{val}}</option>
        </select>
        <select
          class="s-select separate"
          v-model="queryInfo.category"
        >
          <option value="">请选择类型</option>
          <option
            v-for="(item,index) in dict_info_category"
            :key="index"
            :value="index"
          >{{item}}</option>
        </select>
        <input
          type="button"
          class="s-btn"
          value="搜索"
          @click="pageCallback(1)"
        >
        <div
          class="add-btn"
          @click="showEditWindow('add')"
        >新建</div>
      </form>
      <div id="list">
        <table v-if="tableData.length">
          <tr class="l_header">
            <th>标题</th>
            <th>类型</th>
            <th>状态</th>
            <th>发布时间</th>
            <th
              class="action"
              width="180"
            >操作</th>
          </tr>
          <tr
            class="item"
            v-for="(item,index) in tableData"
            :key="index"
          >
            <td>{{item.title}}<div
                class="suggestion"
                v-if="item.audit_suggestion"
              >?<span>{{item.audit_suggestion}}</span></div>
            </td>
            <td>{{dict_info_category[item.category]}}</td>
            <td :class="'itemStatus itemStatus' + item.status">{{ infoSatus[item.status] }}</td>
            <td>{{item.publishDate?item.publishDate:'--'}}</td>
            <td class="action">
              <router-link
                class="edit"
                href="javascript:;"
                :to="'/www/news/detail?id='+item.id+'&category='+item.category"
              >预览</router-link>
              <a
                v-if="item.status==2 && item.username==localUser.user_name"
                class="edit"
                href="javascript:;"
                @click="querySingle(item.id)"
              >编辑</a>
              <a
                v-if="item.status==0 && localUser.role!=3 "
                class="edit"
                href="javascript:;"
                @click="changeStatus(item.id,2)"
              >设为编辑中</a>
              <a
                v-if="item.status==1 && (localUser.role!=3 || item.username==localUser.user_name)"
                class="nopublish"
                href="javascript:;"
                @click="unpublish(item.id)"
              >取消发布</a>
              <a
                v-if="item.status==0  && (localUser.role!=3 || item.username==localUser.user_name)"
                class="publish"
                href="javascript:;"
                @click="publish(item.id)"
              >发布</a>

              <a
                v-if="item.status==2 && localUser.role==3  && item.username==localUser.user_name"
                class="edit"
                href="javascript:;"
                @click="changeStatus(item.id,3)"
              >提交审核</a>
              <a
                v-if="item.status==3  && (localUser.role==0 || localUser.role==2)"
                class="edit"
                href="javascript:;"
                @click="showExamineWindow(item.id)"
              >审核</a>
              <a
                v-if="item.status==2 && item.username==localUser.user_name  "
                class="delete"
                href="javascript:;"
                @click="askDelete(item.id)"
              >删除</a>

            </td>
          </tr>
        </table>
        <div
          class="noitems"
          v-else
        >没有数据</div>
      </div>
      <!-- 分页 -->
      <pagination
        :cur='pageInfo.page'
        :all='pageInfo.all'
        :totalData="pageInfo.totalData"
        :callback="pageCallback"
      ></pagination>
    </div>
    <div
      class="form_overlay"
      id="form_overlay"
      :style="classShowEditWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel editor">
        <div class="form_title">添加/编辑资讯</div>
        <div class="form_content">
          <form id="itemForm">
            <div class="item">
              <span class="label"><i class="require">*</i>标题:</span>
              <input
                type="hidden"
                v-model="formInfo.id"
              >
              <input
                type="text"
                v-model="formInfo.title"
                maxlength="50"
              >
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>类型:</span>
              <select v-model="formInfo.category">
                <option value="">请选择</option>
                <option
                  v-for="(item,index) in dict_info_category"
                  :key="index"
                  :value="index"
                >{{item}}</option>
              </select>
            </div>
            <div class="item">
              <span class="label"><i class="require"></i>缩略图:</span>
              <div class="item-box">
                <input
                  type="text"
                  id="imgurl"
                  disabled="disabled"
                  v-model="formInfo.logo"
                >
                <span
                  class="button"
                  id="uploadImg"
                  @click="showImageWindow"
                >添加图片</span>
              </div>
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>来源:</span>
              <select
                name=""
                id=""
                v-model="formInfo.source"
              >
                <option value="">请选择</option>
                <option
                  v-for="(val,key) in dict_info_source"
                  :key="key"
                  :value="key"
                >
                  {{val}}
                </option>
              </select>
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>资讯内容:</span>
              <div class="k-container1 ">
                <vue-ueditor-wrap
                  v-model="formInfo.contents"
                  :config="editorConfig"
                  editor-id="editor-demo-01"
                ></vue-ueditor-wrap>
              </div>
            </div>
            <div class="item">
              <span class="label"><i class="require"></i>上传附件:</span>
              <div class="item-box">
                <span
                  class="button"
                  id="uploadImg"
                  @click="showFileWindow"
                >附件上传</span>
              </div>
            </div>
            <div class="item">
              <div class="item-box">
                <div
                  v-for="(item,index) in fileList"
                  :key="index"
                >
                  <span>{{item.name}}</span>
                  <span @click="delFile(index)">x</span>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            id="form_close"
            @click="hideEditWindow"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            id="form_submit"
            @click="saveInfo"
          >提交</a>
        </div>
      </div>
    </div>
    <div
      id="dialog_overlay"
      class=""
      :style="classShowImageWindow"
    >
      <div id="dialog_bg"></div>
      <div
        id="dialog_panel"
        style="margin-left: -137px; margin-top: -84px;"
        class=""
      >
        <div id="dialog_panel_bg"></div>
        <div id="dialog_title">选择图片</div>
        <div id="dialog_content">
          <div
            class="imgType"
            style="margin-bottom:10px;"
            id="imgType"
          >允许上传的图片格式：jpg</div>
          <div
            id="thumbPreview"
            v-show="showImgPreview"
          ><img ref="headImg"></div>
          <div>
            <input
              id="imageFile"
              type="file"
              accept=".jpg"
              ref="imageFile"
              @change="imageFileChange"
            >
          </div>
        </div>
        <div id="dialog_control">
          <a
            href="javascript:void(0)"
            @click="hideImageWindow"
            id="dialog_close"
            class="button"
            style="display: inline-block;"
          >取消</a>
          <a
            href="javascript:void(0)"
            @click="confirmImage"
            id="dialog_ok"
            class="button"
            style="display: inline-block;"
          >确认</a>
        </div>
      </div>
    </div>
    <div
      id="dialog_overlay"
      class=""
      :style="classShowFileWindow"
    >
      <div id="dialog_bg"></div>
      <div
        id="dialog_panel"
        style="margin-left: -137px; margin-top: -84px;"
        class=""
      >
        <div id="dialog_panel_bg"></div>
        <div id="dialog_title">选择图片</div>
        <div id="dialog_content">
          <div
            class="imgType"
            style="margin-bottom:10px;"
            id="imgType"
          >允许上传的文件格式：doc,docx,pdf,ppt,jpg,png,gif,xls</div>
          <div>
            <input
              id="imageFile"
              type="file"
              accept=".doc,.docx,.pdf,.ppt,.jpg,.png,.gif,.xls"
              ref="fileUpload"
              @change="fileUploadChange"
            >
          </div>
        </div>
        <div id="dialog_control">
          <a
            href="javascript:void(0)"
            @click="hideFileWindow"
            id="dialog_close"
            class="button"
            style="display: inline-block;"
          >取消</a>
          <a
            href="javascript:void(0)"
            @click="confirmFile"
            id="dialog_ok"
            class="button"
            style="display: inline-block;"
          >确认</a>
        </div>
      </div>
    </div>
    <div
      class="form_overlay"
      id="form_overlay"
      :style="classShowPubWindow"
    >
      <div class="form_overlay_bg"></div>
      <div
        class="form_panel editor"
        style="width: 550px;"
      >
        <div class="form_title">发布资讯</div>
        <div class="form_content">
          <form id="itemForm">
            <div class="item">
              <span class="label"><i class="require">*</i>标题:</span>
              <input
                type="hidden"
                v-model="formPub.id"
              >
              <input
                type="date"
                v-model="formPub.publishDate"
              >
            </div>
            <div class="clearfix"></div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            id="form_close"
            @click="hidePubWindow"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            id="form_submit"
            @click="pubInfo"
          >提交</a>
        </div>
      </div>
    </div>
    <!-- 审核 -->
    <div
      class="form_overlay"
      :style="classShowExamineWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">审核资讯</div>
        <div class="form_content">
          <form id="itemForm">
            <div class="item">
              <span class="label"><i class="require">*</i>审核结果:</span>
              <form method="post">
                <input
                  type="radio"
                  style="margin-right:5px"
                  v-model="auditInfo.status"
                  value="0"
                >通过
                <input
                  type="radio"
                  style="margin-left:10px;margin-right:5px"
                  v-model="auditInfo.status"
                  value="2"
                >不通过
              </form>
            </div>
            <div
              class="item"
              v-if="auditInfo.status==2"
            >
              <span class="label"><i class="require">*</i>修改意见:</span>
              <textarea
                rows="5"
                v-model="auditInfo.audit_suggestion"
              ></textarea>
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            id="form_close"
            @click="hideExamineWindow"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            id="form_submit"
            @click="examineBtn"
          >提交</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap'
import Pagination from '../../../components/Pager'
export default {
  name: 'Info',
  components: {
    VueUeditorWrap,
    Pagination
  },
  data() {
    return {
      classShowEditWindow: {},
      classShowPubWindow: {},
      queryInfo: {
        page: 1,
        size: 10,
        title: '',
        publishDate_min: '',
        publishDate_max: '',
        category: '',
        status: ''
      },
      infoSatus: {
        0: '未发布',
        1: '已发布',
        2: '编辑中',
        3: '待审核'
      },
      formInfo: {
        id: 0,
        title: '',
        logo: '',
        contents: '',
        category: '',
        username: '',
        name: '',
        isdel: 0,
        source: '',
        status: 2
      },
      auditInfo: {
        id: 0,
        status: '0',
        audit_suggestion: ''
      },
      formPub: {
        id: 0,
        publishDate: ''
      },
      tableData: [],
      tableDataCount: 0,
      editorConfig: {
        // 访问 UEditor 静态资源的根路径，可参考 https://hc199421.gitee.io/vue-ueditor-wrap/#/faq
        UEDITOR_HOME_URL: '/UE/',
        // 服务端接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        // serverUrl: '//ueditor.szcloudplus.com/cos',
        serverUrl: this.$store.state.uEditorServerUrl,
        autoHeight: true,
        // imagePathFormat: '/files/{yyyy}{mm}{dd}-{time}{rand:6}',
        // imageUrlPrefix: 'http://localhost:8000'
        initialFrameWidth: '100%',

        initialFrameHeight: 300
      },
      classShowImageWindow: {},
      classShowFileWindow: {},
      showImgPreview: false,
      fileList: [],
      fileObj: {
        name: '',
        path: ''
      },
      sensitiveWord: [],
      classShowExamineWindow: {}
    }
  },
  // 计算属性
  computed: {
    dict_info_category() {
      return this.$store.state.dict_info_category
    },
    dict_info_source() {
      return this.$store.state.dict_info_source
    },
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    },
    localUser() {
      return this.$store.state.userInfo
    }
  },
  methods: {
    formTableImageSrc(src) {
      if (src !== '') {
        return src
      } else {
        return ''
      }
    },
    showImageWindow() {
      this.classShowImageWindow = {
        visibility: 'visible'
      }
    },
    hideImageWindow() {
      this.classShowImageWindow = {}
    },
    showFileWindow() {
      this.classShowFileWindow = {
        visibility: 'visible'
      }
    },
    hideFileWindow() {
      this.classShowFileWindow = {}
    },
    async imageFileChange() {
      const uploadUrl = '/info_files/' + this.$refs.imageFile.files[0].name
      await this.$http.put(uploadUrl, this.$refs.imageFile.files[0]).then((data) => {
        this.uploaded_img = data
        this.showImgPreview = true
        this.$refs.headImg.src = data
      }).catch(() => {
        this.$parent.showMsg('上传失败！')
      })
    },
    async fileUploadChange() {
      const uploadUrl = '/info_files/' + this.$refs.fileUpload.files[0].name

      await this.$http.put(uploadUrl, this.$refs.fileUpload.files[0]).then((data) => {
        this.fileObj = {
          name: this.$refs.fileUpload.files[0].name,
          path: data
        }
      }).catch(() => {
        this.$parent.showMsg('上传失败！')
      })
    },
    confirmImage() {
      this.formInfo.logo = this.uploaded_img
      this.hideImageWindow()
    },
    confirmFile() {
      this.fileList.push(this.fileObj)

      this.hideFileWindow()
    },
    // 编辑时查询
    async querySingle(id) {
      const url = '/info/' + id + '/'
      await this.$http.get(url).then((data) => {
        this.formInfo = {
          id: id,
          title: data.title,
          logo: data.logo,
          date: data.date,
          contents: data.contents,
          category: data.category ? data.category : '',
          status: data.status,
          username: data.user_name,
          name: data.name,
          isdel: 0,
          filePath: data.filePath ? JSON.parse(data.filePath) : [],
          source: data.source,
          level: data.level
        }
        this.fileList = this.formInfo.filePath
        this.showEditWindow('edit')
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('数据获取失败！')
      })
    },
    // 提交信息
    async saveInfo() {
      if (!this.formInfo.title) {
        this.$parent.showMsg('请输入标题!')
        return false
      }
      if (this.formInfo.title.length > 50) {
        this.$parent.showMsg('标题长度不能超过50!')
        return false
      }
      if (!this.formInfo.category) {
        this.$parent.showMsg('请选择类型!')
        return false
      }
      if (!this.formInfo.source) {
        this.$parent.showMsg('请选择来源!')
        return false
      }
      if (!this.formInfo.contents) {
        this.$parent.showMsg('请输入内容!')
        return false
      }
      if (this.localUser.role !== 3) {
        this.formInfo.status = 0
      }
      const isRight = this.utils.getWords(this.formInfo.contents, this.sensitiveWord)
      if (isRight) {
        this.$layer.msg('输入的内容有敏感词!')
        return false
      }
      this.formInfo.filePath = JSON.stringify(this.fileList)
      if (this.formInfo.id) {
        const url = '/info/' + this.formInfo.id + '/'
        await this.$http.put(url, this.formInfo).then((data) => {
          if (data.id) {
            this.$parent.showMsg('修改成功！')
            this.hideEditWindow()
            this.search()
          } else {
            this.$parent.$parent.showMsg('修改失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('修改失败！')
        })
      } else {
        if (this.localUser.role === 2) {
          this.formInfo.level = 2
        } else if (this.localUser.role === 3) {
          this.formInfo.level = 3
        } else {
          this.formInfo.level = 4
        }
        await this.$http.post('/info/', this.formInfo).then((data) => {
          if (data.id) {
            this.$parent.showMsg('添加成功！')
            this.hideEditWindow()
            this.search()
          } else {
            this.$parent.showMsg('添加失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('添加失败！')
        })
      }
    },
    // 发布
    async pubInfo() {
      if (!this.formPub.publishDate) {
        this.$parent.showMsg('请选择发布日期!')
        return false
      }
      if (this.formPub.id) {
        const url = '/info_pub/'
        await this.$http.post(url, {
          id: this.formPub.id,
          publishDate: this.formPub.publishDate,
          status: 1
        }).then((data) => {
          if (data.code === '200') {
            this.$parent.showMsg('发布成功！')
            this.hidePubWindow()
            this.search()
          } else {
            this.$parent.$parent.showMsg('发布失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('发布失败！')
        })
      }
    },
    async search() {
      await this.$http.get('/info/', {
        params: this.queryInfo
      }).then((data) => {
        this.tableData = data.results
        this.tableDataCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    },
    // 取消发布
    unpublish(id) {
      this.$parent.showConfirm('确定要取消发布吗？', async () => {
        await this.$http.post('/info_pub/', {
          id: id,
          status: 0,
          publishDate: null
        }).then((data) => {
          this.$parent.showMsg('取消发布成功！')
          this.search()
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('取消发布失败！')
        })
      })
    },
    // 发布
    publish(id) {
      this.formPub.id = id
      this.formPub.publishDate = ''
      this.classShowPubWindow = { visibility: 'visible' }
    },

    // 删除
    async askDelete(id) {
      const url = '/info/' + id + '/'
      await this.$parent.showConfirm('确认删除此条数据吗?', () => {
        this.$http.put(url, {
          isdel: 1
        }).then((data) => {
          this.$parent.showMsg('删除成功！')
          this.search()
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('删除失败！')
        })
      })
    },
    showEditWindow(value) {
      if (value === 'add') {
        this.formInfo = {
          id: 0,
          title: '',
          logo: '',
          date: '',
          category: '',
          contents: '',
          username: this.localUser.user_name,
          name: this.localUser.name,
          status: 2,
          isdel: 0,
          filePath: []
        }
        this.fileList = this.formInfo.filePath
      }

      this.classShowEditWindow = { visibility: 'visible' }
    },
    hideEditWindow() {
      this.classShowEditWindow = { visibility: 'hidden' }
    },
    hidePubWindow() {
      this.classShowPubWindow = { visibility: 'hidden' }
    },
    // 分页
    async pageCallback(data) {
      this.queryInfo.page = data
      await this.search()
    },
    delFile(index) {
      this.fileList.splice(index, 1)
    },
    // 获取敏感词
    async getSensitiveWord() {
      await this.$http.get('/sensitiveword/', {
        params: {
          page: 1,
          size: 10000,
          status: 1
        }
      }).then((data) => {
        if (data.results.length) {
          data.results.forEach(item => {
            if (item.words) {
              const wordList = item.words.split('\n')
              for (let i = 0; i < wordList.length; i++) {
                this.sensitiveWord.push(wordList[i])
              }
            }
          })
        } else {
          this.sensitiveWord = []
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    // 打开审核弹窗
    showExamineWindow(id) {
      this.auditInfo.id = id
      this.auditInfo.status = 0
      this.auditInfo.audit_suggestion = ''
      this.classShowExamineWindow = {
        visibility: 'visible'
      }
    },
    hideExamineWindow() {
      this.classShowExamineWindow = {}
    },
    // 审核
    async examineBtn() {
      if (Number(this.auditInfo.status) !== 0 && !this.auditInfo.audit_suggestion) {
        this.$layer.msg('修改意见不能为空')
        return
      }
      await this.$http.put('/info/' + this.auditInfo.id + '/', {
        status: this.auditInfo.status,
        audit_suggestion: this.auditInfo.audit_suggestion
      }).then((data) => {
        this.$layer.msg('提交成功！')
        this.search()
        this.hideExamineWindow()
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('提交失败！')
      })
    },
    // 更改状态
    async changeStatus(id, code) {
      await this.$http.put('/info/' + id + '/', {
        status: code
      }).then((data) => {
        this.$layer.msg('操作成功！')
        this.search()
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('操作失败！')
      })
    }
  },
  mounted() {
    this.search()
    this.getSensitiveWord()
  }
}
</script>
<style lang="less" scoped>
.k-container1 {
  float: left;
  max-width: 700px;
}
.form_content .item input[type="text"],
.form_content .item input[type="password"],
.form_content .item input[type="number"],
.form_content .item input[type="date"] {
  /* background: #fbfbfb; */
  border: 1px solid #dddddd;
  height: 32px;
  line-height: 32px;
  width: 302px;
  box-sizing: border-box;
  padding: 0 5px;
}
.item-box {
  & > div {
    padding-left: 110px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    span {
      &:last-child {
        display: inline-block;
        padding: 0 5px;
        background: red;
        color: #fff;
        line-height: 18px;
        margin-left: 5px;
        cursor: pointer;
      }
    }
  }
}
.suggestion {
  width: 15px;
  height: 15px;
  border: 1px solid #e91919;
  border-radius: 50%;
  display: inline-block;
  color: #e91919;
  text-align: center;
  line-height: 15px;
  font-size: 12px;
  margin-left: 5px;
  cursor: pointer;
  position: relative;
}
.suggestion:hover span {
  display: block;
}
.suggestion span {
  display: none;
  position: absolute;
  left: -20px;
  top: -50px;
  border: 1px solid #dddddd;
  width: 150px;
  height: auto;
  background: #fff;
  padding: 10px 5px;
  box-sizing: border-box;
}
.suggestion span::before {
  content: "";
  width: 0px;
  height: 0px;
  border: 9px solid transparent;
  border-top-color: #dddddd;
  position: absolute;
  bottom: -18px;
  left: 19px;
}
.suggestion span::after {
  content: "";
  width: 0px;
  height: 0px;
  border: 8px solid transparent;
  border-top-color: #fff;
  position: absolute;
  bottom: -16px;
  left: 20px;
}
</style>
